import { Star, Award } from "lucide-react";
import { TRADE_MAP, STATUS } from "@/lib/hz";

export const TradeBadge = ({ trade }) => {
  const t = TRADE_MAP[trade];
  if (!t) return null;
  const Icon = t.icon;
  return (
    <span className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-xs font-semibold ${t.chip}`}>
      <Icon className="size-3" /> {t.name}
    </span>
  );
};

export const StatusBadge = ({ status }) => {
  const s = STATUS[status] ?? { label: status, cls: "bg-slate-100 text-slate-700" };
  return <span data-testid="job-status-badge" className={`inline-flex rounded-full px-2.5 py-0.5 text-xs font-semibold ${s.cls}`}>{s.label}</span>;
};

export const Stars = ({ value = 0, count, size = "size-4" }) => (
  <span className="inline-flex items-center gap-1.5">
    <span className="inline-flex">
      {[1, 2, 3, 4, 5].map((i) => (
        <Star key={i} className={`${size} ${i <= Math.round(value) ? "fill-amber-400 text-amber-400" : "fill-slate-200 text-slate-200"}`} />
      ))}
    </span>
    <span className="text-sm font-bold text-slate-900">{Number(value || 0).toFixed(1)}</span>
    {count != null && <span className="text-sm text-slate-500">({count})</span>}
  </span>
);

export const BadgeCount = ({ n }) =>
  n > 0 ? (
    <span className="inline-flex items-center gap-1 rounded-full bg-violet-50 px-2 py-0.5 text-xs font-semibold text-violet-700">
      <Award className="size-3" /> {n} {n === 1 ? "insignia" : "insignias"}
    </span>
  ) : null;
